export default 'ontouchstart' in window
